import { useState, FormEvent } from "react";

const FinalCTASection = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [consent, setConsent] = useState(false);
  const [status, setStatus] = useState<"idle" | "sending" | "success" | "error">("idle");

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!formData.name || !formData.phone || !consent) return;
    setStatus("sending");
    try {
      const body = new URLSearchParams();
      body.append("name", formData.name);
      body.append("email", formData.email);
      body.append("phone", formData.phone);
      body.append("message", formData.message);
      const res = await fetch("https://readdy.ai/api/form/d7066att4s7j0tv5inl0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      if (res.ok) {
        setStatus("success");
        setFormData({ name: "", email: "", phone: "", message: "" });
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  };

  return (
    <section id="kontakt" className="py-20 lg:py-28 bg-[#0B1D42]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="text-white">
            <span className="inline-block text-[#93C5FD] text-sm font-semibold tracking-wide uppercase mb-4">
              Kontakt
            </span>
            <h2 className="text-3xl lg:text-4xl font-bold mb-5 leading-tight">
              Chcesz więcej klientów z internetu?
            </h2>
            <p className="text-white/70 text-lg leading-relaxed mb-8">
              Zostaw kontakt lub zadzwoń — przygotuję propozycję dopasowaną do Twojej branży i lokalizacji. Bezpłatna konsultacja, bez zobowiązań.
            </p>

            <div className="flex flex-col gap-5">
              <a
                href="tel:+48509963499"
                className="flex items-center gap-4 cursor-pointer group"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/10 group-hover:bg-white/20 transition-colors">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-phone-fill text-xl text-white"></i>
                  </div>
                </div>
                <div>
                  <p className="text-white/50 text-xs">Zadzwoń</p>
                  <p className="text-white font-semibold">+48 509 963 499</p>
                </div>
              </a>
              <a
                href="mailto:tomasz.kdp@gmail.com"
                className="flex items-center gap-4 cursor-pointer group"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/10 group-hover:bg-white/20 transition-colors">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-mail-line text-xl text-white"></i>
                  </div>
                </div>
                <div>
                  <p className="text-white/50 text-xs">Napisz e-mail</p>
                  <p className="text-white font-semibold">tomasz.kdp@gmail.com</p>
                </div>
              </a>
            </div>
          </div>

          <div className="bg-white rounded-xl p-8">
            <h3 className="text-xl font-bold text-[#1A1A2E] mb-6">
              Wyślij zapytanie
            </h3>

            {status === "success" ? (
              <div className="flex flex-col items-center gap-4 py-8 text-center">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-green-50">
                  <div className="w-7 h-7 flex items-center justify-center">
                    <i className="ri-check-line text-2xl text-green-500"></i>
                  </div>
                </div>
                <div>
                  <p className="font-semibold text-[#1A1A2E] text-lg mb-1">Dziękuję!</p>
                  <p className="text-gray-500 text-sm">
                    Odezwę się do Ciebie w ciągu 24 godzin.
                  </p>
                </div>
              </div>
            ) : (
              <form
                data-readdy-form
                onSubmit={handleSubmit}
                className="flex flex-col gap-4"
              >
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    Imię i nazwa firmy <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    required
                    value={formData.name}
                    onChange={(e) =>
                      setFormData({ ...formData, name: e.target.value })
                    }
                    placeholder="Jan Kowalski / Firma Kowalski"
                    className="w-full border border-gray-200 rounded-md px-4 py-2.5 text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-[#0F2557] transition-colors"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    Telefon <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    required
                    value={formData.phone}
                    onChange={(e) =>
                      setFormData({ ...formData, phone: e.target.value })
                    }
                    placeholder="+48 500 000 000"
                    className="w-full border border-gray-200 rounded-md px-4 py-2.5 text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-[#0F2557] transition-colors"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    E-mail
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                    placeholder="jan@firma.pl"
                    className="w-full border border-gray-200 rounded-md px-4 py-2.5 text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-[#0F2557] transition-colors"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    Czym się zajmuje Twoja firma?
                  </label>
                  <textarea
                    name="message"
                    rows={3}
                    maxLength={500}
                    value={formData.message}
                    onChange={(e) =>
                      setFormData({ ...formData, message: e.target.value })
                    }
                    placeholder="Np. montaż ogrodzeń w Krakowie i okolicach..."
                    className="w-full border border-gray-200 rounded-md px-4 py-2.5 text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-[#0F2557] transition-colors resize-none"
                  />
                  <p className="text-xs text-gray-400 mt-1">
                    {formData.message.length}/500 znaków
                  </p>
                </div>

                <label className="flex items-start gap-3 cursor-pointer group">
                  <input
                    type="checkbox"
                    name="consent"
                    required
                    checked={consent}
                    onChange={(e) => setConsent(e.target.checked)}
                    className="mt-0.5 w-4 h-4 flex-shrink-0 accent-[#0F2557] cursor-pointer"
                  />
                  <span className="text-xs text-gray-500 leading-relaxed">
                    Wyrażam zgodę na przetwarzanie moich danych osobowych przez Administratora w celu odpowiedzi na zapytanie, zgodnie z{" "}
                    <a href="/polityka-prywatnosci" target="_blank" className="text-[#0F2557] underline hover:no-underline">Polityką Prywatności</a>.
                    Zgoda jest dobrowolna i można ją wycofać w dowolnym momencie. <span className="text-red-500">*</span>
                  </span>
                </label>

                {status === "error" && (
                  <p className="text-red-500 text-sm">
                    Wystąpił błąd. Spróbuj ponownie lub zadzwoń bezpośrednio.
                  </p>
                )}

                <button
                  type="submit"
                  disabled={status === "sending" || !consent}
                  className="whitespace-nowrap w-full py-3 rounded-md font-semibold text-sm bg-[#0F2557] text-white hover:bg-[#1B3D7A] transition-colors cursor-pointer disabled:opacity-60"
                >
                  {status === "sending" ? "Wysyłanie..." : "Sprawdź ile możesz mieć zapytań"}
                </button>

                <p className="text-xs text-gray-400 text-center">
                  Odezwę się do Ciebie w ciągu 24 godzin. Bez spamu.
                </p>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
